module.exports = __webpack_public_path__ + "static/marcela-490a3c2425a8a1dacb7386725c47a581.jpg";